export default __webpack_public_path__ + "static/media/722.32b08026.jpg";